/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeckInvestmentCompany } from './deck-investment-company';

export interface PaginatedDeckInvestmentCompanyList {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: Array<DeckInvestmentCompany>;
}
